'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
var CardColumnWrapper = require('./CardColumnWrapper.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Card column wrapper image
 *
 * Helps to define an (overflowing) image inside various cards
 *
 * @internal Used internally by [Anything]Card components.
 */
var CardColumnWrapperImage = react.forwardRef(function (props, ref) {
  var styles = CardColumnWrapper.useStyles();
  return /*#__PURE__*/React__default["default"].createElement(react.chakra.img, _extends__default["default"]({
    ref: ref,
    __css: styles.image
  }, props));
});
CardColumnWrapperImage.displayName = 'CardColumnWrapperImage';
exports.CardColumnWrapperImage = CardColumnWrapperImage;